import axios from 'axios';
import { loadingActions, filemanagerActions } from '../redux/actions';
import { Store } from '../redux/stores';
import resourceCache from './resourcesCache';

export const uploadFiles = (files, fileNames, tableId, updateStatusFn) => {
    Store.dispatch(loadingActions.loadingStart('resources.uploadFiles'));
    let formData = new FormData();

    if (tableId) {
        formData.append("tableId", tableId);
    }

    files.forEach((file, i) => {
        formData.append("uploadedFiles", file.file);
        formData.append("fileNames", fileNames[i]);
    });

    let resp = axios.post(process.env.REACT_APP_HOST + '/resources/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function(progressEvent) {
            let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            updateStatusFn(percentCompleted);
        }
    });
    Store.dispatch(loadingActions.loadingEnd('resources.uploadFiles'));

    resp.then((res) => {
        let fileList = [];
        if (res && res.data && res.data.payload) {
            fileList = res.data.payload.files;
        }
        Store.dispatch(filemanagerActions.setFiles(fileList));
    });
    return resp;
    
};


export const getFiles =  async (tableId) => {
    Store.dispatch(loadingActions.loadingStart('resources.getFiles'));
    const defaultReposne = {status:'error', payload: {files:[]}};
    try {
        let resp = await axios.get(process.env.REACT_APP_HOST + '/resources/' + (tableId || ''));
        Store.dispatch(loadingActions.loadingEnd('resources.getFiles'));
        let payload = defaultReposne.payload;
        if (resp && resp.data) {
            payload = resp.data.payload;
        }
        Store.dispatch(filemanagerActions.setFiles(payload.files));
        return payload;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('resources.getFiles'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultReposne;
    }
};

export const getResource =  async (fileId) => {
    return axios.get(process.env.REACT_APP_HOST + '/resources/file/' + fileId, { 
        responseType: 'arraybuffer'
    });
};

export const getImageResource = async (fileId, isThumbnail=false) => {
    if (!fileId) {
        return '';
    }

    let resId = fileId;
    if (isThumbnail) {
        resId = '_'+fileId;
    }

    let d = await resourceCache.get(resId);
    if (d !== null) {
        return d;
    }

    let promiseValue = new Promise(async (resolve, reject) => {

        Store.dispatch(loadingActions.loadingStart('resources.getImageResource'));
        let img = await axios.get(process.env.REACT_APP_HOST + '/resources/file/' + fileId + (isThumbnail ? '?thumb=1' : ''), { 
            responseType: 'arraybuffer'
        }).then((res) => {
            let image = btoa(
                new Uint8Array(res.data)
                    .reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
            resourceCache.set(resId, `data:${res.headers['content-type'].toLowerCase()};base64,${image}`);

            Store.dispatch(loadingActions.loadingEnd('resources.getImageResource'));
            return resourceCache.get(resId);
        }).catch((error) => {
            return '';
        });
        Store.dispatch(loadingActions.loadingEnd('resources.getImageResource'));

        resolve(img);
    });

    resourceCache.set(resId, promiseValue);
    return await promiseValue;
};


export const removeFiles =  async (tableId, filesSelected) => {
    Store.dispatch(loadingActions.loadingStart('resources.removeFiles'));
    const defaultReposne = {status:'error', payload: {files:[]}};
    try {
        let resp = await axios.delete(process.env.REACT_APP_HOST + '/resources/' + (tableId || ''), {
            data: {
                ids: filesSelected.map(i => i.id)
            }
        });
        Store.dispatch(loadingActions.loadingEnd('resources.removeFiles'));
        let payload = defaultReposne.payload;
        if (resp && resp.data) {
            payload = resp.data.payload;
        }
        Store.dispatch(filemanagerActions.setFiles(payload.files));
        return payload;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('resources.removeFiles'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultReposne;
    }
};

const ImageBatch = {};
export const getImageElement = async (fileId) => {
    return new Promise(async (resolve, reject) => {
        if (ImageBatch[fileId]) {
            resolve({
                object: ImageBatch[fileId],
                state: 'ok'
            });
            return;
        }
        
        let imgData = await getImageResource(fileId);
        if (imgData) {
            ImageBatch[fileId] = new Image();
            ImageBatch[fileId].src = imgData;
            ImageBatch[fileId].onload = () => {
                resolve({
                    object: ImageBatch[fileId],
                    state: 'ok'
                });
            }
        } else {
            reject();
        }
    });
}

export const reportBug = (files, description, tableId) => {
    Store.dispatch(loadingActions.loadingStart('resources.reportBug'));
    let formData = new FormData();

    if (description) {
        formData.append("description", description);
    }
    if (tableId) {
        formData.append("tableId", tableId);
    }

    files.forEach((file, i) => {
        formData.append("screenFiles", file);
    });

    let resp = axios.post(process.env.REACT_APP_HOST + '/bugreport', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    Store.dispatch(loadingActions.loadingEnd('resources.reportBug'));

    return resp;
};